<script>
import { mapGetters } from 'vuex';

export default {
  name: 'has-filters',
  computed: {
    ...mapGetters([
      'getUserID'
    ]),
    currentViewNameForFilters () {
      let name = this.$options.name + '-' + this.$route.path.replace(/[^a-z0-9]/gmi, '');

      if (this.popupFilter) {
        name += '-' + this.popupFilter;
      }

      if (this.popupStatus) {
        name += '-' + this.popupStatus;
      }

      return name;
    }
  },
  data () {
    return {
      initialFilterValues: {}
    };
  },
  beforeMount () {
    if (!this.disableFiltersInSubview) {
      this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
      this.loadFilters();
    }
  },
  mounted () {
    if (!this.disableFiltersInSubview) {
      this.$bus.$on('view-filters-save', this.saveFilters);
      this.$bus.$on('view-filters-reset', this.resetFilters);
    }
  },
  methods: {
    loadFilters () {
      const storageKey = 'headwear-crm-filters-' + parseInt(this.getUserID, 10) + '-' + this.currentViewNameForFilters;
      const savedData = localStorage.getItem(storageKey);

      if (!savedData) {
        this.resetFilters();
        return;
      }

      let filtersData = JSON.parse(savedData);
      this.filters = JSON.parse(JSON.stringify({ ...this.initialFilterValues, ...filtersData }));
    },
    saveFilters () {
      localStorage.setItem('headwear-crm-filters-' + parseInt(this.getUserID, 10) + '-' + this.currentViewNameForFilters, JSON.stringify(this.filters));
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    if (!this.disableFiltersInSubview) {
      this.$bus.$off('view-filters-save', this.saveFilters);
      this.$bus.$off('view-filters-reset', this.resetFilters);
    }
  }
};
</script>
